import Icon from "@components/_Revamp/Icon";
import React, { useCallback, useEffect, useState } from "react";

interface TooltipProps {
  title: string;
  isIcon?: boolean;
  children: any;
}

export const Tooltip = (props: TooltipProps) => {
  const { title, isIcon, children } = props;

  const detectScreenWidth = useCallback(() => {
    setTooltipPosition(window.innerWidth, true);
  }, []);

  useEffect(() => {
    setTooltipPosition(window.innerWidth, true);
    window.addEventListener("scroll", setTooltipPosition);
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("scroll", setTooltipPosition);
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, []);

  return (
    <span className={isIcon ? "toolTip icon" : "toolTip"}>
      <span id="info">
        {isIcon ? <Icon name="info-gray-solid" /> : { title }}
      </span>
      <span className="top">
        <span className="tooltipHeader">{title}</span>
        {children}
      </span>
    </span>
  );
};

export const setTooltipPosition = (screenSize?: any, resize?: boolean) => {
  const elems: any = document.querySelectorAll(".toolTip");
  const MAX_CHILD_ELEMENTS =  3;
  if (elems.length > 0) {
    for (let i = 0; i < elems.length; i++) {
      const topEle = elems[i].querySelector(".top");
      const infoEle = elems[i].querySelector("#info");
      const rectTopEle = topEle.getBoundingClientRect();
      const rect = elems[i].getBoundingClientRect();

      if (rect.top < rectTopEle.height + 64) {
        elems[i].classList.add("bottom");
      } else {
        elems[i].classList.remove("bottom");
      }

      if (resize) elems[i].classList.remove("right");
      if (rectTopEle.left > screenSize - rectTopEle.width) {
        elems[i].classList.add("right");
      }
      infoEle.addEventListener("touchend", (e:any)=>{
        const grayBgElement = document.createElement("span");
        grayBgElement.className = "gray_area";
        if(elems[i].childElementCount < MAX_CHILD_ELEMENTS) {
          elems[i].appendChild(grayBgElement)
          const grayArea = elems[i].querySelector(".gray_area");
          grayArea.addEventListener("touchend", (e:any)=>{
            elems[i].classList.remove("active");
          });
        }
        elems[i].classList.add("active");
      } );
      topEle.addEventListener("touchend", (e:any)=>{
        elems[i].classList.remove("active");
      });
      
    }
  }
};
